import baseAPI from '@/http'

const router = 'api/pergunta/perguntaevidencia'

export const evidenceQuestionAPI = {
  update: (pergunta) => baseAPI.put(router, pergunta),
  delete: (perguntaId) => baseAPI.delete(`${router}/${perguntaId}`, perguntaId),
  download: (id) => baseAPI.post(`/api/arquivo/evidencia/download/${id}`, null, { responseType: 'blob' }),
  finalizarAnalise: (perguntas) => baseAPI.put(`${router}/finalizar-evidencia`, perguntas),


}
